module.exports = __webpack_public_path__ + "static/media/shape_3.51fdec0c.png";